export default __webpack_public_path__ + "static/media/querelle_detail5.4dd762b8.jpg";